import { RESOURCE_TYPE_MAP } from './resource-type';

/**
 * Providers whose assets are all code: repositories and the files in them.
 * Azure DevOps and CodeCommit repositories carry the Azure and AWS providers,
 * so they count as code only through their integration's category.
 */
export const CODE_PROVIDERS = ['GitHub', 'GitLab', 'Bitbucket'];

/** Every code asset type (Code::Git::Repository, Code::Terraform::File, ...). */
export const CODE_RESOURCE_TYPES = Object.keys(RESOURCE_TYPE_MAP.Code ?? {});

/**
 * The provider RESOURCE_TYPE_MAP lists these assets' types under. Code asset
 * types are listed under Code, whichever provider hosts them.
 */
export const catalogProvider = (
  provider: string | undefined,
  category?: unknown,
): string | undefined =>
  category === 'code' || (provider && CODE_PROVIDERS.includes(provider))
    ? 'Code'
    : provider;
